import { CSSProperties } from 'react';

const labelSplitBySpaces = (tick: string): string[] => {
  const idx = tick.indexOf(' ');
  if (idx) {
    return [tick.slice(0, idx), tick.slice(idx + 1)];
  }
  return [tick];
};

const labelSplitByLinebreak = (tick: string): string[] => {
  return tick.split('\n');
};

const cssBoldFirstLine = (idx: number): CSSProperties => {
  if (idx === 0) {
    return { fontWeight: 700 };
  }
  return {};
};

export default {
  css: {
    cssBoldFirstLine,
  },
  label: {
    labelSplitBySpaces,
    labelSplitByLinebreak,
  },
};
